import React from "react";
import { Skeleton } from "../ui/Skeleton";

export const StudentCardSkeleton = () => {
  return (
    <div
      className="basis-auto pl-32px"
      data-testid="student-carousel-card-skeleton"
    >
      <div className="relative flex flex-col gap-1">
        <Skeleton className="size-[160px]" />
        <div className="flex flex-col gap-1">
          <Skeleton className="h-[25px] w-32" />
          <div className="flex items-center gap-1">
            <Skeleton className="h-4 w-4 rounded-sm" />
            <Skeleton className="h-4 w-20 rounded-sm" />
          </div>
        </div>
      </div>
    </div>
  );
};
